<router-outlet></router-outlet>
<app-loader></app-loader>
<router-outlet></router-outlet>